import { render, staticRenderFns } from "./CarList.vue?vue&type=template&id=8b0e8030&scoped=true"
import script from "./CarList.vue?vue&type=script&lang=js"
export * from "./CarList.vue?vue&type=script&lang=js"
import style0 from "./CarList.vue?vue&type=style&index=0&id=8b0e8030&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0e8030",
  null
  
)

export default component.exports